export const SET_STATIC_PAGES = 'legal/SET_STATIC_PAGES';

export const setStaticPages = (staticPages) => ({
    type: SET_STATIC_PAGES,
    payload: {
        staticPages,
    },
});
